//Atoms
import Div from '../Atoms/div';

function PopUp(props){
	return(
		<Div size="menu" type="popup" children={props.text} />
	)
}
export default PopUp
